<template>
  <div>
    <survey-list 
      v-if="feature === 'survey-list'"
      :userId="$store.getters.user.id"
      :clientId="$store.getters.clientId"
    />
    <rewards-and-recognition
      v-if="feature === 'rewards-and-recognition'"
      :clientId="$store.getters.user.client_id"
      :userId="$store.getters.user.id"
      title=""
    />
  </div>
</template>

<script>
  import { SurveyList } from 'ewage-portal-surveys'
  import RewardsAndRecognition from 'ewage-portal-rewards-and-recognition'

  export default {
    name: 'feature-loader',
    props: {
      feature: {
        type: String,
        required: true
      }
    },
    components: { 
      SurveyList,
      RewardsAndRecognition
    }
  }
</script>

<style lang="scss" scoped>
  ::v-deep .surveys-list {
    background: white;
    border-radius: 5px;
  }
</style>